import { render, staticRenderFns } from "./seal.vue?vue&type=template&id=bb315660&scoped=true&"
import script from "./seal.vue?vue&type=script&lang=js&"
export * from "./seal.vue?vue&type=script&lang=js&"
import style0 from "./seal.vue?vue&type=style&index=0&id=bb315660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb315660",
  null
  
)

export default component.exports